import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ChatPageComponent from '../components/ChatPage';
import ChatSkeleton from '../components/ChatSkeleton';
import { Companion } from '../api/model';
import { useServices } from '../hooks/useServices';
import { ROUTES } from '../routes';

const ChatPage: React.FC = () => {
  const navigate = useNavigate();
  const { companionId } = useParams<{ companionId: string }>();
  const [companion, setCompanion] = useState<Companion | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { companionService } = useServices();

  useEffect(() => {
    if (companionId) {
      loadCompanion(companionId);
    }
  }, [companionId]);

  const loadCompanion = async (id: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await companionService.getCompanionById(id);
      if (response.success && response.data) {
        setCompanion(response.data);
      } else {
        setError('Companion not found');
      }
    } catch (err) {
      setError('Failed to load companion');
      console.error('Error loading companion:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate(ROUTES.HOME);
  };

  if (!companionId) {
    // If no companion ID, redirect to home
    navigate(ROUTES.HOME);
    return null;
  }

  if (loading) {
    return <ChatSkeleton onBackToHome={handleBackToHome} />;
  }

  if (error || !companion) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-kind-text-primary mb-2">
            {error || 'Companion not found'}
          </h2>
          <button
            onClick={handleBackToHome}
            className="px-4 py-2 bg-kind-purple text-white rounded-lg hover:bg-kind-purple/80 transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return <ChatPageComponent companion={companion} onBackToHome={handleBackToHome} />;
};

export default ChatPage;
